<div *ngIf="isFeatureLoading" class="one3d-features-loader-box w-100 h-100">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 200 200"
    class="loader-image"
  >
    <circle
      cx="100"
      cy="100"
      r="70"
      fill="none"
      stroke-width="15"
      stroke-linecap="round"
      opacity="0.2"
      [attr.stroke]="primaryColor"
    ></circle>
    <circle
      cx="100"
      cy="100"
      r="70"
      fill="none"
      stroke-width="15"
      stroke-linecap="round"
      stroke="url(#a10)"
      stroke-dasharray="200 500"
      class="rotating-circle"
    ></circle>
    <defs>
      <radialGradient id="a10" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)">
        <stop offset="0" [attr.stop-color]="primaryColor"></stop>
        <stop offset=".3" [attr.stop-color]="primaryColor" stop-opacity=".9"></stop>
        <stop offset=".6" [attr.stop-color]="primaryColor" stop-opacity=".6"></stop>
        <stop offset=".8" [attr.stop-color]="primaryColor" stop-opacity=".3"></stop>
        <stop offset="1" [attr.stop-color]="primaryColor" stop-opacity="0"></stop>
      </radialGradient>
    </defs>
  </svg>
</div>
<!-- For 3d load -->
<div
  class="one3d-canvas"
  id="one3d"
  [hidden]="
    isFeatureLoading || featureType === '2D_Image' || featureType === '2D_Video'
  "
  [@cardAnimator]="globalService.animationState"
  #one3dCanvasContainer
></div>
<!-- For 2d image type feature-->
<div
  class="one3d-canvas"
  [hidden]="isFeatureLoading"
  *ngIf="featureType === '2D_Image' && featureUrl"
  [@cardAnimator]="globalService.animationState"
>
  <img [src]="featureUrl" alt="peugeot-feature-img" (load)="onImageLoad()" />
</div>
<!-- For 2d video type feature-->
<div
  class="one3d-canvas"
  [hidden]="isFeatureLoading"
  *ngIf="featureType === '2D_Video' && featureUrl"
  [@cardAnimator]="globalService.animationState"
>
  <video
    width="100%"
    (canplay)="onCanVideoPlay(one3d_video)"
    height="100%"
    playsinline
    autoplay
    loop
    #one3d_video
    id="one3d_video"
  >
    <source id="one3d_source" [src]="featureUrl" type="video/mp4" />
  </video>
</div>
<div class="one3d-canvas-overlap-wrapper" [hidden]="!showImageAccessory">
  <div class="one3d-canvas-overlap">
    <img
      id="img"
      [src]="accessoryImageUrl"
      alt="Canvas car images"
      (load)="imageLoadCompleted()"
      [hidden]="!imageLoaded"
    />
    <p class="one3d-image-loading-placeHolder" [hidden]="imageLoaded" translate>
      ONE_3D.LOADING_IMAGE
    </p>
    <!-- <img src="assets/img/one3d-acc-canvas.png" alt="" /> -->
  </div>
</div>
